import SEO from "@/components/SEO";
import { useSettings } from "@/context/SettingsContext";

const Section = ({ title, children }) => (
  <div className="mb-7">
    <h2 className="mb-2 font-display text-xl font-bold text-navy">{title}</h2>
    <p className="leading-relaxed text-gray-600">{children}</p>
  </div>
);

export default function Privacy() {
  const s = useSettings();
  return (
    <>
      <SEO title="Privacy Policy | Happy Holidays Wale" description="How Happy Holidays Wale collects, uses and protects your personal information." />
      <div className="mx-auto max-w-3xl px-4 py-14 md:px-8">
        <h1 className="font-display text-4xl font-extrabold text-navy">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-400">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>
        <div className="mt-8">
          <Section title="1. Information We Collect">We collect information you provide when making an enquiry or booking, including your name, phone number, email, travel dates and preferences. This helps us craft the best holiday experience for you.</Section>
          <Section title="2. How We Use Your Information">Your information is used to process bookings, respond to enquiries, send travel updates and payment reminders, and improve our services. We never sell your data to third parties.</Section>
          <Section title="3. Data Security">We implement industry-standard security measures to protect your personal information against unauthorised access, alteration or disclosure.</Section>
          <Section title="4. Communication">By submitting an enquiry, you consent to being contacted by our team via phone, email or WhatsApp regarding your travel requirements.</Section>
          <Section title="5. Cookies">Our website uses cookies to enhance your browsing experience and remember your preferences.</Section>
          <Section title="6. Contact Us">For any privacy-related questions, contact us at {s?.email || "hi.happyholidays@gmail.com"}.</Section>
        </div>
      </div>
    </>
  );
}
